module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-ajax-156.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/vue-ajax.md
// module id = 574
// module chunks = 221